(async () => {
    if (!customElements.get("compare-products")) {
        const {
            default: Swiper,
            Navigation,
            Pagination
        } = await import("./swiper.esm-357e3607.async.js");
        Swiper.use([Navigation, Pagination]);
        class CompareProducts extends HTMLElement {
            constructor() {
                super();
                const self = this;
                this.coupleSets = document.querySelector("couple-sets-selector");
                this.swiperElement = this.querySelector("[data-swiper]");
                this.buttonPrev = this.querySelector(".swiper-button-prev");
                this.buttonNext = this.querySelector(".swiper-button-next");
                this.swiperOptions = {
                    loop: false,
                    autoplay: false,
                    threshold: 10,
                    direction: "horizontal",
                    navigation: {
                        nextEl: this.buttonNext,
                        prevEl: this.buttonPrev
                    },
                    pagination: {
                        el: ".swiper-pagination-wrapper",
                        type: "custom",
                        renderCustom: function(swiper, current, total) {
                            return `\n              <div class="field">\n                <div class="select">\n                  <select class="field__select" data-compare-select>\n                ${swiper.slides.map(((slide,i)=>`<option ${i===current-1?"selected":""} value="${i}">${slide.dataset.productTitle}</option>`))}\n                </select>\n                <svg class="icon icon-arrow-down" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="presentation" viewBox="0 0 18 15" fill="none"><path d="M9.32104 15L0.660789 -1.63133e-06L17.9813 -1.17124e-07L9.32104 15Z" fill="currentColor"></path></svg>\n                </div>\n              </div>\n              `
                        }
                    }
                };
                this.swiperInstance = new Swiper(this.swiperElement, {
                    ...this.swiperOptions,
                    on: {
                        init: function(swiper) {
                            const select = swiper.pagination.$el[0].querySelector("[data-compare-select]");
                            select.addEventListener("change", (function() {
                                self.changeProduct(swiper, this.value)
                            }))
                        },
                        slideChange: function(swiper) {
                            const select = swiper.pagination.$el[0].querySelector("[data-compare-select]");
                            select.addEventListener("change", (function() {
                                self.changeProduct(swiper, parseInt(this.value))
                            }))
                        },
                        transitionEnd: function(swiper) {
                            if (self.coupleSets) {
                                self.coupleSets.firstActiveSlide = document.querySelectorAll("compare-products")[0].querySelector(".swiper-slide-active");
                                self.coupleSets.secondActiveSlide = document.querySelectorAll("compare-products")[1].querySelector(".swiper-slide-active");
                                self.coupleSets.positionElements();
                                self.getID(swiper)
                            }
                        }
                    }
                })
            }
            changeProduct(swiper, value) {
                swiper.slideTo(value)
            }
            getID(swiper) {
                if (swiper.el.parentNode.dataset.couplesetId == "1") {
                    this.coupleSets.productID1 = swiper.slides[swiper.activeIndex].dataset.productId
                } else if (swiper.el.parentNode.dataset.couplesetId == "2") {
                    this.coupleSets.productID2 = swiper.slides[swiper.activeIndex].dataset.productId
                }
                this.coupleSets.checkSets()
            }
        }
        window.CompareProducts = CompareProducts;
        customElements.define("compare-products", CompareProducts)
    }
    class CoupleSetSelector extends CompareProducts {
        constructor() {
            super();
            this.coupleSetsJSON = JSON.parse(this.dataset.couplesetJson);
            this.formWrapper = document.getElementById("couple-set-form");
            this.form = this.formWrapper.querySelector("form");
            this.formElements = this.form.elements;
            this.firstActiveSlide = document.querySelectorAll("compare-products")[0].querySelector(".swiper-slide-active");
            this.secondActiveSlide = document.querySelectorAll("compare-products")[1].querySelector(".swiper-slide-active");
            this.productID1 = this.firstActiveSlide.dataset.productId;
            this.productID2 = this.secondActiveSlide.dataset.productId;
            this.checkSets();
            this.positionElements();
            this.debounceOnResize = debounce((event => {
                this.positionElements()
            }), 100);
            window.addEventListener("resize", this.debounceOnResize.bind(this))
        }
        checkSets(productID1 = this.productID1, productID2 = this.productID2, el1 = this.firstActiveSlide, el2 = this.secondActiveSlide) {
            document.querySelector(".compare__content").classList.remove("show-atc");
            this.formElements.add.setAttribute("disabled", true);
            productID1 = parseInt(productID1);
            productID2 = parseInt(productID2);
            this.firstActiveSlide = document.querySelectorAll("compare-products")[0].querySelector(".swiper-slide-active");
            this.secondActiveSlide = document.querySelectorAll("compare-products")[1].querySelector(".swiper-slide-active");
            const matchingSets = this.coupleSetsJSON.filter((set => set.id1 === productID1 && set.id2 === productID2 || set.id1 === productID2 && set.id2 === productID1));
            if (matchingSets.length > 0) {
                if (matchingSets.length > 1) {
                    console.error("Too many matches, please check the json!")
                }
                this.positionElements(el1, el2);
                const url = `/products/${matchingSets[0].couplesetHandle}?view=price-info`;
                fetch(url).then((response => response.text())).then((responseText => {
                    const parsedHTML = (new DOMParser).parseFromString(responseText, "text/html");
                    const productID = parsedHTML.getElementById("product-id").value;
                    let priceContent;
                    if (parsedHTML.getElementById("compare-at-price").innerHTML !== "") {
                        priceContent = `\n              <dl class="price__sale">\n                <dt>\n                  <span class="visually-hidden visually-hidden--inline">${this.formWrapper.dataset.textSale}</span>\n                </dt>\n                <dd>\n                  <span class="price-item price-item--sale">${parsedHTML.getElementById("price").innerHTML}</span>\n                </dd>\n                <dt>\n                  <span class="visually-hidden visually-hidden--inline">${this.formWrapper.dataset.textRegular}</span>\n                </dt>\n                <dd class="price__compare">\n                  <s class="price-item price-item--regular">${parsedHTML.getElementById("compare-at-price").innerHTML}</s>\n                </dd>\n              </dl>`
                    } else {
                        priceContent = `\n              <dl class="price__sale">\n                <dt>\n                  <span class="visually-hidden visually-hidden--inline">${this.formWrapper.dataset.textRegular}</span>\n                </dt>\n                <dd>\n                  <span class="price-item price-item--sale">\n                    ${parsedHTML.getElementById("price").innerHTML}\n                  </span>\n                </dd>\n              </dl>`
                    }
                    this.form.querySelector("[data-couple-set-price-wrapper]").innerHTML = priceContent;
                    this.form.id = `product_form_${productID}`;
                    this.formElements.id.value = productID;
                    this.formElements.add.removeAttribute("disabled");
                    document.querySelector(".compare__content").classList.add("show-atc")
                })).catch((error => {
                    //debug() && console.error(error)
                }))
            }
        }
        positionElements(el1 = this.firstActiveSlide, el2 = this.secondActiveSlide) {
            const productMeta1 = el1.querySelector(".product-card__meta");
            const productMeta2 = el2.querySelector(".product-card__meta");
            productMeta1.removeAttribute("style");
            productMeta2.removeAttribute("style");
            if (productMeta1.clientHeight !== productMeta2.clientHeight) {
                const minHeight = Math.max(productMeta1.clientHeight, productMeta2.clientHeight);
                productMeta1.style.minHeight = `${minHeight}px`;
                productMeta2.style.minHeight = `${minHeight}px`
            }
            const offset = Math.max(el1.querySelector("[data-product-card]").clientHeight, el2.querySelector("[data-product-card]").clientHeight);
            const wrapper = el1.closest("compare-products");
            this.formWrapper.style.top = `${document.querySelector("h1").clientHeight+16+25+64+wrapper.querySelector(".swiper-pagination-wrapper").clientHeight+42+offset+20}px`
        }
    }
    if (!customElements.get("couple-sets-selector")) {
        customElements.define("couple-sets-selector", CoupleSetSelector)
    }
})();
//# sourceMappingURL=main-compare.js.map